export { default } from './StaticPageView'
